module.exports = __webpack_public_path__ + "static/sport/icon-2.d606145.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/september10/icon-2.png
// module id = c/Rb
// module chunks = 0